import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_e_079e0ebf7fe83aa9d657b5e1cb981165/node_modules/nuxt/dist/pages/runtime/validate.js";
import access_45global from "/app/middleware/access.global.ts";
import meta_45global from "/app/middleware/meta.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_e_079e0ebf7fe83aa9d657b5e1cb981165/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  access_45global,
  meta_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "recent-pages": () => import("/app/middleware/recent-pages.ts")
}